import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initTheme } from './lib/theme';
import { restore } from './lib/session';
import './styles/tokens.css';
import './styles/theme-dark.css';
import './styles/app.css';

initTheme();

// Bring back a signed-in guest before first paint if their tokens are still
// good, refreshing silently when the hour is up. Deliberately not awaited: the
// app shell is the first thing two hundred people load on hotel wifi, and it
// must not wait on a token endpoint to render (D47). `useSession` re-renders
// whoever cares when it lands.
void restore();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
